var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file",
    clipPath: "url(#clip0_8876_384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.370117 17.3037H59.6294V55.1852C59.6294 57.637 57.6368 59.6296 55.1849 59.6296H4.81456C2.36271 59.6296 0.370117 57.637 0.370117 55.1852V17.3037Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.6294 17.3037V13.2593C59.6294 10.8074 57.6368 8.81482 55.1849 8.81482H31.3701C30.7183 8.81482 30.0886 8.56296 29.6146 8.11111L22.2738 1.07407C21.7997 0.622223 21.1701 0.370371 20.5183 0.370371H4.81456C2.36271 0.370371 0.370117 2.36296 0.370117 4.81482V17.3037H59.6294Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.2817 17.3037V16.037C53.2817 14.4 51.9558 13.0741 50.3187 13.0741H9.68171C8.04468 13.0741 6.71875 14.4 6.71875 16.037V17.3037H53.2817Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.0664 31.3185C27.0664 29.6963 28.3775 28.3852 29.9997 28.3852C31.622 28.3852 32.9331 29.6963 32.9331 31.3185V36.2074C32.9331 37.8296 31.622 39.1407 29.9997 39.1407C28.3775 39.1407 27.0664 37.8296 27.0664 36.2074V31.3185Z",
    fill: "#1E1F22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.9108 45.0593C34.4516 45.0593 34.8886 45.4963 34.8886 46.037C34.8886 46.5778 34.4516 47.0148 33.9108 47.0148H26.0886C25.5479 47.0148 25.1108 46.5778 25.1108 46.037C25.1108 45.4963 25.5479 45.0593 26.0886 45.0593H29.0219V42.9778C25.7108 42.5037 23.1553 39.6519 23.1553 36.2148C23.1553 35.6741 23.5923 35.237 24.1331 35.237C24.6738 35.237 25.1108 35.6741 25.1108 36.2148C25.1108 38.9111 27.3034 41.1037 29.9997 41.1037C32.696 41.1037 34.8886 38.9111 34.8886 36.2148C34.8886 35.6741 35.3256 35.237 35.8664 35.237C36.4071 35.237 36.8442 35.6741 36.8442 36.2148C36.8442 39.6519 34.2886 42.5037 30.9775 42.9778V45.0593H33.9108Z",
    fill: "#1E1F22"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8876_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.838916e6045c22337e44ba9b72352366.svg";
export { ForwardRef as ReactComponent };